import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;

@Injectable()
export class LearnService {
header: string;
  constructor(private http: HttpClient, private httpClientService: HttpClientService,
    private adobeAnalyticsService: AdobeAnalyticsService) { }

  getLearnPage(learnPageUrl) {
    return this.httpClientService.get(learnPageUrl)
      .pipe(
       map((res: HttpResponse<any>) => res.body)
      ,catchError( this.handleError ));
  }

  createPageLoadProperties(url?) {
    const dataLayer = {};
    if (url === 'ELIGIBILITYMODAL') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = '/virtual/eligibilityerrormodal.html';
    }
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS['FRIENDLY_NAME_' + url];
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_LEARN;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Other';

    if (sessionStorage.getItem('sapmp_jwtToken') != null) {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'home';
    }
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  handleError(error) {
    return throwError(error);
  }
  requestSupportContent(id, pageName) {
    return this.httpClientService.get(id + pageName)
  .pipe(
       map((res: HttpResponse<any>) => res.body)
  ,catchError( this.handleError ));
}
  get_headers() {
  let headers = new HttpHeaders();
  headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
  return headers;
}
}

